// FLAG TO REGISTER POPUP
var popup_height = "400";
const formIdElement= document.getElementById("tangent-form-id");
addPopupHtml();

function showPopup() {
    // Attempt to find the popup element
    const popupElement = document.getElementById("exit-intent-popup");

    // Ensure the popup element exists before proceeding
    if (popupElement) {
        // Display the popup and make it visible
        popupElement.style.display = "flex";
        popupElement.classList.add('visible');
    } else {
        console.error("Popup element with ID 'exit-intent-popup' not found.");
        return;
    }		
}


function close_pop() {
    document.getElementById("exit-intent-popup").style.display = "none";
	document.querySelector('.exit-intent-popup').classList.remove('visible');
}

function bindEvent(element, eventName, eventHandler) {
	if (element.addEventListener) {
		element.addEventListener(eventName, eventHandler, false);
	} else if (element.attachEvent) {
		element.attachEvent('on' + eventName, eventHandler);
	} else {
		console.warn(`Event binding not supported for ${eventName} on this element.`);
	}
}


function createPopupDiv() {
	const popupDiv = document.createElement("div");
	popupDiv.id = 'exit-intent-popup';
	popupDiv.classList.add("exit-intent-popup");
	return popupDiv;
}


function buildIframeUrl(shopId, formId) {
	const baseUrl = "https://a.tangent.ai/quiz-app/1.0.89/";
	const queryParams = `?shop_id=${shopId}&amp;form_id=${formId}&amp;quiz_type=popup`;
	return baseUrl + queryParams;
}

function buildIframeHtml(iframeUrl) {
	return `
        <iframe id='tangent-popup-iframe' title='Selfie quiz' allow='camera' frameborder='0' allowtransparency='true' width='100%' scrolling='no' style='overflow: hidden;' src='${iframeUrl}'></iframe>`;
}

function appendPopupToBody(popupDiv) {
  document.body.appendChild(popupDiv);
}

function addNavOpenEvent() {
  window.addEventListener("hashchange", function(event) {
    if(event.newURL.includes("#shade-finder")){
      showPopup();
      history.replaceState(null, "", window.location.pathname);
      //window.location.hash = '';
    }
  });
}

function addCloseButtonEvent() {
	const closeButton = document.getElementById('close_btn');
	if (closeButton) {
		closeButton.addEventListener('click', close_pop);
	} else {
		console.error("Close button not found.");
	}
}

function addPopupHtml() {
  	// let formId = "670ccd49e819d69ce3f9c4e4";
   //  if(type=='inline'){
   //    formId = "66d56814f79caa7a594679ff";
   //  }
  formId = formIdElement.innerHTML;
	const shopId = "56905564315";

	const iframeUrl = buildIframeUrl(shopId, formId);
	const iframeHtml = buildIframeHtml(iframeUrl);

	const popupDiv = createPopupDiv();
    
	popupDiv.innerHTML = `
    <div id='tangent-popup-container'>
      <div id='tangent-popup-image-container'>
        <img id="tangent-popup-image" src='https://haleysbeauty.com/cdn/shop/files/BestSeller_1d93078b-bdcb-4519-af5d-48641fe95414_900x.jpg?v=1635958536'/>
      </div>
      <div id="tangent-iframe-container">${iframeHtml}</div>
      <div id="recommendation-section" class="hide">
        <div id="recommendation-sub-container">
          <div id="recommendation-content-section">
            <div><img id="selfie_img" src=""/></div>
            <div id="checkout-description-container">
              <p id="recommendation-heading"></p>
              <div id="checkout-description"></div>
            </div>
          </div>
          <div id="recommendation-products-section"></div>
        </div>
      </div>
      
      <span id='close_btn' class='close'>
          <img src='https://a.tangent.ai/DND/general/closebutton.png' alt='Close' width='20'>
      </span>
    </div>`;

	appendPopupToBody(popupDiv);
    addNavOpenEvent();
	addCloseButtonEvent();
}

// Listen to message from child window
bindEvent(window, 'message', function(e) {
	handleMessage(e);
});

function handleMessage(e) {
	switch (typeof e.data) {
		case 'string':
			handleStringMessage(e.data);
			break;
		case 'number':
			// handleNumberMessage(e.data);
			break;
		default:
			break;
	}
}

function handleStringMessage(data) {
  const objState = isJsonString(data);
  
  if (objState) {
      try {
          const obj = JSON.parse(data);
  
          // Handle popup quiz type with page type
          if (obj.quiz_type === "popup" && obj.type === "page") {
              handlePageType(obj);
          }
  
          // Handle response ID
          if (obj.resp_id) {
              hideTangentElement();
              showRecommendationSection();
              loadProducts(obj.resp_id);
          }
      } catch (error) {
          console.error("Failed to parse JSON data:", error);
      }
  } else {
      console.error("Provided data is not a valid JSON string:", data);
  }

}

function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function handlePageType(obj) {
  const popupContainer = document.getElementById("tangent-popup-container");
  if (obj.key === 'scrollTop') {
    handleScrollTop(popupContainer);
  } else if (obj.key === 'iframe-height') {
    // handleIframeHeight(popupContainer, obj.value);
  }
}

function handleScrollTop(popupContainer) {
  const headerOffset = 105;
  if (popupContainer !== undefined) {
    const elementPosition = popupContainer.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    popupContainer.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}
  
function handleIframeHeight(popupContainer, height) {
  const popupHeight = height === 0 ? popup_height : height;
  const styleString = popupHeight < popup_height 
    ? `display: flex;height:${popup_height}px;` 
    : `display: flex;height:${popup_height}px;`;

  if (popupContainer !== undefined) {
    popupContainer.setAttribute("style", styleString);
  }

  const popupIframe = document.getElementById("tangent-popup-iframe");
  if (popupIframe !== undefined) {
    popupIframe.setAttribute("style", `height:${popupHeight}px;margin-bottom:0px`);
  }
}

function handleNumberMessage(height) {
	const tangentElement = document.getElementById("tangent-popup-iframe");
	const ex_height = tangentElement.style.height;

	if (height !== ex_height && height !== 0) {
		tangentElement.style.height = `${height}px`;
		document.getElementById("popup-container").style.height = "inherit";
	}

	if (height > 300) {
		tangentElement.style.minHeight = "unset";
	}
}

function hideTangentElement() {
	const tangentElement = document.getElementById("tangent-iframe-container");
	tangentElement.style.display = "none";
}

function showRecommendationSection() {
	const recommendationSection = document.getElementById("recommendation-section");
	recommendationSection.classList.remove("hide");
}

async function loadProducts(resp_id) {
	if (resp_id != null) {
		const checkout_url = `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${resp_id}`;
		try {
			const response = await fetch(checkout_url);
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			const data = await response.json();
			handleSuccess(data);
		} catch (error) {
			console.error("Error in server call:", error);
		}
	}
}

function hidePopupImage(){
  const popupImageContainer = document.getElementById("tangent-popup-image-container");
  popupImageContainer.classList.add("hide");
}

function handleSuccess(data) {
    if(data.selfie_url){
    	setSelfieImage(data.selfie_url);
    }
    hidePopupImage();
	const products = data.products;
  
	if (products.length > 0) {
		// const allToCart = buildAllToCartUrl(products);
		// showAddAllToCartButton(allToCart);
		renderProducts(products);
	} else {
		displayNoProductsMessage();
	}

	if (data.description !== '') {
		showCheckoutDescription(data.description);
	}
}

function setSelfieImage(url) {
	document.getElementById("selfie_img").src = url;
}

function buildAllToCartUrl(products) {
	return products.reduce((url, product, index) => {
		const separator = index === 0 ? '' : '&id[]=';
		return `${url}${separator}${product.variants[0].id}`;
	}, "https://haleysbeauty.com/cart/add?id[]=");
}

function showAddAllToCartButton(url) {
	const addAllToCart = document.getElementById("add-all-to-cart");
	addAllToCart.style.display = "block";
	addAllToCart.href = url;
}

function renderProducts(products) {
	const selected_pdt = {};
	products.forEach((product, p) => {
		selected_pdt[product.id] = product.variants[0].id;
		const variants_div = createVariantsDiv(product, p);
		appendProductToSection(product, p, variants_div);
	});
}

function createVariantsDiv(product, p) {
	const variants_div = document.createElement("div");
	variants_div.id = 'variants_div';
	variants_div.style.display = "none";

	if (product.variants.length > 0) {
		const variantsub_div = document.createElement("div");
		variants_div.appendChild(variantsub_div);
		const _variants = product.variants;

		// if (_variants.length > 1) {
		// 	variants_div.style.display = "block";
		// 	_variants.forEach((variant, v) => {
		// 		const v_img = createVariantImage(variant, v, p);
		// 		variantsub_div.appendChild(v_img);
		// 	});
		// }
	}
	return variants_div;
}

function createVariantImage(variant, v, p) {
	const v_img = document.createElement("img");
	v_img.id = `variant_${v}:product_${p}`;
	v_img.title = variant.title;
	v_img.addEventListener('click', function() {
		changeVariant(this);
	}, false);

	if (v === 0) {
		v_img.classList.add('selected-variant');
	}

	const key2search = variant.title.replace(/ /g, "");

	return v_img;
}

function appendProductToSection(product, p, variants_div) {
	const productsSection = document.getElementById("recommendation-products-section");
	productsSection.insertAdjacentHTML('beforeend', `
      <div>
        <a class="text-link" target="_blank" href="/products/${product.handle}">
          <p class="product-title"><b>${product.title}</b></p>
          <img class="tangent-popup-product-img" src="${product.images[0].src}">
        </a>
        <div id="product_${p}"></div>
      </div>
    `);
	document.getElementById(`product_${p}`).appendChild(variants_div);

    appendPriceText(p, product);
  
    appendAddToCartButton(p, product.variants[0].id);
}

function appendPriceText(index, product){
  const price_text = document.createElement("p");
  price_text.innerText = `$${product.variants[0].price}`;
  price_text.classList.add('prdt-price');
  document.getElementById(`product_${index}`).appendChild(price_text);
}

function appendAddToCartButton(index, product_id){
  const addToCartButton = document.createElement("button");
  addToCartButton.id=product_id;
  addToCartButton.innerText = `ADD TO CART`;
  addToCartButton.classList.add('add-to-cart-button');
  addToCartButton.addEventListener('click',function () { addToCart(this); },false);
  document.getElementById(`product_${index}`).appendChild(addToCartButton);
}

function displayNoProductsMessage() {
	const recommendationHeading = document.getElementById("recommendation-heading");
	recommendationHeading.innerHTML = 'Thank you for completing our quiz, we will get back to you soon!';
	recommendationHeading.style.padding = "0";
	document.getElementById("recommendation-products-section").style.display = "none";
}

function showCheckoutDescription(description) {
	const checkoutDescription = document.getElementById("checkout-description");
	checkoutDescription.style.display = "block";
	checkoutDescription.innerHTML = description;
}

function changeVariant(ele) {
	const {
		vId,
		pId
	} = parseElementId(ele.id);
	const pdt = products[pId];
	const var_id = getVariantId(pdt, ele.title);
	updateSelectedProduct(pdt.id, var_id);
	updateAllToCartLink();
	updateSelectedVariantClass(ele, pId);
}

function parseElementId(eleId) {
	const [vIdText, pIdText] = eleId.split(":");
	const vId = parseInt(vIdText.substring(vIdText.lastIndexOf('_') + 1));
	const pId = parseInt(pIdText.substring(pIdText.lastIndexOf('_') + 1));
	return {
		vId,
		pId
	};
}

function getVariantId(pdt, title) {
	let var_id = pdt.variants[0].id;
	if (pdt.variants.length > 1) {
		const variant = pdt.variants.find(v => v.title === title);
		if (variant) {
			var_id = variant.id;
		}
	}
	return var_id;
}

function updateSelectedProduct(pdtId, var_id) {
	selected_pdt[pdtId] = var_id;
}

function updateAllToCartLink() {
	let allToCart = "/cart/add?id[]=";
	let c = 0;
	for (const pid in selected_pdt) {
		allToCart += c === 0 ? selected_pdt[pid] : `&id[]=${selected_pdt[pid]}`;
		c++;
	}
	$('#add-all-to-cart').attr('href', allToCart);
}

function updateSelectedVariantClass(ele, pId) {
	const shade_imgs = document.getElementsByClassName('shade-img');
	for (const item of shade_imgs) {
		if (item.classList.contains('selected-variant')) {
			const {
				pId: itemPId
			} = parseElementId(item.id);
			if (itemPId === pId) {
				item.classList.remove('selected-variant');
			}
		}
		if (ele.id === item.id) {
			item.classList.add('selected-variant');
		}
	}
}

function addToCart(button) {
  console.log("add to cart ",button.id);
  addItemToShopifyCart(button.id);
  updateCartButton(button.id);
}

function addItemToShopifyCart(pid) {
  let formData = {
   'items': [{
    'id': pid,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    updateCartButton(pid);
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateCartButton(pid) {
	const button = document.getElementById(pid);
  
	button.text("Added to Cart!");
	button.css({
		"background-color": "#56565b",
		"cursor": "none",
		"pointer-events": "none"
	});
}